<template>
  <div id="ContractEquipmentUtilization">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Contract Equipment Utilization</div>
          <div class="web-action-btn btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'contractEquipmentUtilization'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'contractEquipmentUtilization'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                      mode="remote"
                      ref="contractEquipmentUtilizationTable"
                      title="contractEquipmentUtilization"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      @on-select-all="onSelectAll"
                      @on-selected-rows-change="selectionChanged"
                      :totalRows="totalRecords"
                      :columns="userColumns"
                      :rows="rows"
                      :paginationOptions="{
                          enabled: false,
                          position: 'both',
                          perPage: perPage,
                          dropdownAllowAll: false,
                          setCurrentPage:listCurrentPage,
                          perPageDropdown:dropDownPerPage,
                      }"
                      :select-options="{
                          enabled: false,
                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                          selectionInfoClass: 'custom-class',
                          selectionText: 'rows selected',
                          clearSelectionText: 'clear',
                      }"
                      :search-options="{
                      enabled: false,
                      }"

                >
                </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
            <div class="bg-white text-center">
                <h1>
                    Oops!</h1>
                <h2>
                    403 </h2>
                <div class="error-details">
                    Sorry!, You don't have permission to access this page.
                </div>
            </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
  import Vue from "vue";
  
  
  
  
  
  import {commonMixins} from '../../mixins/commonMixins';
  import {dataTableMixins} from '../../mixins/dataTableMixins';
  export default {
    name: "ContractEquipmentUtilization",
    metaInfo(){
        return {
          title : 'Contract Equipment Utilization | FleetPro Application'
        }
      },
    mixins: [commonMixins,dataTableMixins],
    data: () => ({
      cantAccessPage:"",
      loading: false,
      action: '',
      permissions:[],
      rows: [],
      totalRecords: 0,
      userColumns:[],
      columns:[
          {
              label: 'Customer Name',
              field: 'cust_name',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: 'Customer Number',
              field: 'cust_no',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: 'Customer Group Number',
              field: 'cust_grp_no',
              filterable: false,
              hidden:false,
              fpFieldType:"text",
              sortable:false,
          },
          {
              label: 'Sales Rep',
              field: 'sales_rep',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: "Attachment",
              field: "attachmt",
              filterable: false,
              sortable: false,
              fpFieldType:"option",
              hidden:false,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "All", // placeholder for filter input
                  filterDropdownItems: ['Y','N'],
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              },
          },
          {
              label: 'Unit Number',
              field: 'unit_no',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: 'Unit Owner',
              field: 'ownership',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: 'Date Out',
              field: 'date_out',
              hidden:false,
              fpFieldType:"custom_date",
              filterable: true
          },
          {
              label: 'Date In',
              field: 'date_in',
              hidden:false,
              fpFieldType:"custom_date",
              filterable: true
          },
          {
              label: 'Agmt Type',
              field: 'agreement_type',
              fpFieldType:"text",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'Contract Type',
              field: 'contract_type',
              fpFieldType:"option",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'Agreement Number',
              field: 'agreement_no',
              fpFieldType:"text",
              hidden:false,
              filterable: true,
              sortable: true,
          },
          {
              label: 'Days Utilized in Period',
              field: 'util_in_period',
              fpFieldType:"integer",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
          {
              label: 'Days in Period',
              field: 'days_in_period',
              fpFieldType:"integer",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
          {
              label: 'Pct Utilized in Period',
              field: 'pct_util_in_period',
              fpFieldType:"integer",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
          {
              label: 'Days Utilized Total',
              field: 'days_util_tot',
              fpFieldType:"integer",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
          {
              label: 'Prov/Stat Code',
              field: 'state_code',
              fpFieldType:"option",
              hidden:false,
              filterable: false,
              sortable: true,
          },
          {
              label: 'Vin #',
              field: 'vin',
              fpFieldType:"text",
              hidden:false,
              filterable: true,
              sortable: true,
          },
          {
              label: "Facility Responsible",
              field: "location",
              filterable: true,
              fpFieldType:"option",
              hidden:false,
          },
          {
              label: "Facility Out",
              field: "loc_out",
              filterable: true,
              fpFieldType:"option",
              hidden:false,
          },
          {
              label: "Facility Domicile",
              field: "loc_in",
              filterable: true,
              fpFieldType:"option",
              hidden:false,
          },
          {
              label: 'Replaced Unit',
              field: 'replaced_unit',
              fpFieldType:"text",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'Replaced Agreement Type',
              field: 'replaced_ag_type',
              fpFieldType:"text",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'Replaced Agreement Number',
              field: 'replaced_ag_no',
              fpFieldType:"text",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'Fixed Charges',
              field: 'fixed_charges',
              fpFieldType:"integer",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
          {
              label: 'Variable Charges',
              field: 'var_charges',
              fpFieldType:"integer",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
          {
              label: 'Manual Charges',
              field: 'man_charges',
              fpFieldType:"integer",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
          {
              label: 'Total Charges',
              field: 'tot_charges',
              fpFieldType:"integer",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
          {
              label: "Start Date",
              field: "start_date",
              filterable: false,
              fpFieldType:"text",
              hidden:true,
              sortable: false,
          },
          {
              label: "End Date",
              field: "end_date",
              filterable: false,
              fpFieldType:"text",
              hidden:true,
              sortable: false,
          },
      ],
      batchProcess:0,
      batchNum:"",
    }),
    watch:{
      permissions: function(permission) {
          var self = this;
          permission.forEach(function (permissions) {
              if(permissions.name == 'contract_equipment_utilization') {
                  self.cantAccessPage = true;
              }
          });
          if(self.cantAccessPage == ''){
              self.cantAccessPage = false;
          }
      },
    },
    mounted: function(){
      var self = this;
      self.getPermissions();
    },
    methods:{
      loadList: function(){

        var self = this;
        self.loading = true;
          $.ajax({
              url: process.env.ROOT_API + "/contract-equipment-utilization-report/list",
              type: "POST",
              crossDomain: true,
              headers: this.ajxHeaders,
              dataType: "json",
              data: {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: this.serverParams.columnFilters,
                sort: this.serverParams.sort,
                action: self.action,

              },
              success: function(data) {
                self.loading = false;
                //console.log(data.content[0]["id"]);
                  if (data.status == "success") {

                    if ( self.action == "export" ||  self.action == "export_queue") {

                        if ( data.code == "201" ) {
                            alert(data.message);
                        } else {

                            if ( self.action == "export" ) {

                                self.excel = data.content.web;
                                var save = document.createElement("a");
                                save.href = self.excel;
                                save.download = data.content.web;
                                save.target = "_blank";

                                document.body.appendChild(save);
                                save.click();
                                document.body.removeChild(save);

                            } else {

                                self.batchProcess = 1;
                                self.batchNum = data.content;
                            }

                        }

                        self.action = "list";
                        // self.loadList();
                        return;
                    } else {
                      if (data.content.row != undefined) {
                        self.rows = data.content.row;
                      }
                      self.totalRecords = data.content.totalRecords;
                    }
                  }
              },
              error: function(jqXHR, exception) {
                self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,true,'contract-equipment-utilization')
              }
            });


      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/reports/ContractEquipmentUtilization.vue